import type { auditReports } from '@mi-front/api-clients';

export type ReportDefinitionData = auditReports.ReportDefinitionDataDto;

// Form type that uses 'data' instead of 'definition' for the form structure
export type ReportDefinition = Omit<auditReports.ReportDefinitionDto, 'definition'> & {
  data: ReportDefinitionData;
};
export type BlueprintMetadata = auditReports.BlueprintMetadataDto;
export type BlueprintSection = BlueprintMetadata['sections'][number];
export type BlueprintColumn = BlueprintSection['columns'][number];
export type ReportDefinitionEntity = auditReports.ReportDefinitionEntity;

export type DefinitionDataSection = NonNullable<
  NonNullable<ReportDefinitionData['sections']>[number]
>;

/** Single column in a definition section (with config and label). */
export type DefinitionDataColumn = NonNullable<
  NonNullable<DefinitionDataSection['columns']>[number]
>;

/** Column config shape used by definition columns (type-specific options). */
export type DefinitionColumnConfig = DefinitionDataColumn['config'];

export type Language = 'en' | 'es';
export type Languages = Language[];

// Extract label type from ReportDefinitionDto
export type LocalizedLabel = ReportDefinitionData['sections'][number]['label'];

// Default category ID for columns (changed from 'default' to 'base')
export const DEFAULT_CATEGORY_ID = 'base';
